import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Notification } from './Notification';
import { Link } from '../Typography/Link';
import { WrapperVertical, WrapperHorizontal } from '../../gatsby-theme-docz/components/Wrapper';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "notification"
    }}>{`Notification`}</h1>
    <p>{`Provide contextual feedback messages for typical user actions.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <p>{`Container width is limited to 350px and longer text is wrapped.`}</p>
    <Playground __position={0} __code={'<Notification>Notification</Notification>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Notification,
      Link,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Notification mdxType="Notification">Notification</Notification>
    </Playground>
    <h2 {...{
      "id": "types"
    }}>{`Types`}</h2>
    <Playground __position={1} __code={'<WrapperVertical>\n  <Notification type=\"default\">Default</Notification>\n  <Notification type=\"primary\">Primary</Notification>\n  <Notification type=\"success\">Success</Notification>\n  <Notification type=\"warning\">Warning</Notification>\n  <Notification type=\"error\">Error</Notification>\n  <Notification type=\"info\">Info</Notification>\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Notification,
      Link,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <Notification type="default" mdxType="Notification">Default</Notification>
        <Notification type="primary" mdxType="Notification">Primary</Notification>
        <Notification type="success" mdxType="Notification">Success</Notification>
        <Notification type="warning" mdxType="Notification">Warning</Notification>
        <Notification type="error" mdxType="Notification">Error</Notification>
        <Notification type="info" mdxType="Notification">Info</Notification>
    </WrapperVertical>
    </Playground>
    <h2 {...{
      "id": "other-props"
    }}>{`Other props`}</h2>
    <h3 {...{
      "id": "notification-with-description-text"
    }}>{`Notification with description text`}</h3>
    <Playground __position={2} __code={'<Notification description=\"Notification description\">\n  Notification with description text\n</Notification>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Notification,
      Link,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Notification description="Notification description" mdxType="Notification">Notification with description text</Notification>
    </Playground>
    <h3 {...{
      "id": "notification-with-morelink"
    }}>{`Notification with MoreLink`}</h3>
    <p>{`Add any Link componet for action or redirection`}</p>
    <Playground __position={3} __code={'<Notification\n  MoreLink={\n    <Link href=\"#\" target=\"_blank\">\n      Více\n    </Link>\n  }\n>\n  Notification with MoreLink\n</Notification>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Notification,
      Link,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Notification MoreLink={<Link href="#" target="_blank" mdxType="Link">
                Více
            </Link>} mdxType="Notification">
        Notification with MoreLink
    </Notification>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      